/* global define */

define('paychex.app.messages/drawer/messageDetail/Constants',[], function () {
    'use strict';

    return {messageDetailControllerName: 'MessageDetailController'};
});


